"use strict";

import Drift from 'drift-zoom';
import { LuminousGallery } from 'luminous-lightbox';
import Panzoom from '@panzoom/panzoom';
import 'sly/dist/sly';
import imagesLoaded from 'imagesloaded';
import exportedVars from 'main.scss';

const drifts = [],
      $window = $(window);

$window.on('load resize', function() {
    if ($window.width() >= parseInt(exportedVars.driftZoomBreakpoint)) {
        if (drifts.length === 0) {
            $('.catalogue-gallery-image').each(function(i, img) {
                const $paneContainer = $(img).closest('.product-gallery').find('.drift-zoom-pane-container');
                drifts[i] = new Drift(img, {
                    sourceAttribute: 'data-src-hires',
                    paneContainer: $paneContainer[0],
                    onShow: function() {
                        $paneContainer.removeClass('d-none');
                    },
                    onHide: function() {
                        // Stop from overlaying other elements, once again
                        $paneContainer.addClass('d-none');
                    },
                    injectBaseStyles: false,
                    hoverBoundingBox: true,
                });
            });
        }
    } else {
        if (drifts.length > 0) {
            // Disable drifts on mobile, to allow scrolling by touching
            // the image
            $.each(drifts, function(i, drift) {
                drift.destroy();
            });
            drifts.splice(0, drifts.length);
        }
    }
});

$(function() {
    new LuminousGallery(document.querySelectorAll('.catalogue-gallery-image'), {
        arrowNavigation: true,
    }, {
        sourceAttribute: 'data-src-hires',
        onOpen: function() {
            Panzoom(document.querySelector('.lum-lightbox-image-wrapper'), {
                panOnlyWhenZoomed: true,
            });
        },
    });

    // Disable click action on the thumbnails
    $('.catalogue-gallery-thumbnails a').on('click', function(e){
        e.preventDefault();
    });

    var galleries = $('.catalogue-gallery');
    galleries.each(function(i, gallery){
        var gallery = $(gallery);
        var items = gallery.find('.catalogue-gallery-image, .catalogue-gallery-video');
        gallery.find('.catalogue-gallery-thumbnails-switcher').sly({
            horizontal: true,
            itemNav: 'basic',
            speed: 700,
            smart: true,
            mouseDragging: 1,
            touchDragging: 1,
            releaseSwing: 1,
            backward: gallery.find('.catalogue-gallery-thumbnails-prev'),
            forward: gallery.find('.catalogue-gallery-thumbnails-next'),
            activateOn: 'mouseenter'
        }).sly('on', 'active', function(e, i){
            // Activating the corresponding gallery item
            $(items).removeClass('active');
            $(items[i]).addClass('active');
        });
    });

    // Fix the height of any videos in the gallery
    imagesLoaded('.catalogue-gallery', function(){
        var h = $('.catalogue-gallery-image').height();
        $('.catalogue-gallery-video').css('min-height', h);
    });
});
